import { styled } from "@vitality-ds/system";
import baseIconStyles from "./styles/BaseIcon.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseIcon = styled("svg", baseIconStyles);